import type { IModelConnection } from "@itwin/core-frontend";
import { QueryBinder, QueryRowFormat } from "@itwin/core-common";
import { QAQC } from "../../../domain/contracts/QAQC";
import { DOTPayItemIndex } from "./dotPayItemQuery";

const DOTPAYITEM_SCHEMA =
  "DgnCustomItemTypes_DOT_DigitalAssetMetadata";

/**
 * Build the ECSQL to read QAQC info
 * for a given DOT_PayItem{index} aspect.
 */
function buildQAQCByElementQuery(index: DOTPayItemIndex): string {
  if (index < 1 || index > 5) {
    throw new Error(`Invalid DOT_PayItem index: ${index}`);
  }

  return `
    SELECT
      p.QAQC.MajorCostValue      AS MajorCostValue,
      p.QAQC.MajorTimeValue      AS MajorTimeValue,
      p.QAQC.IsMajorItemLookup   AS IsMajorItemLookup,
      p.QAQC.IsMajorCost         AS IsMajorCost,
      p.QAQC.IsMajorTime         AS IsMajorTime,
      p.QAQC.IsCheckCost         AS IsCheckCost,
      p.QAQC.IsSiblingRequired   AS IsSiblingRequired,
      p.QAQC.PastContractCount   AS PastContractCount,
      p.QAQC.IsCommonItem        AS IsCommonItem,
      p.QAQC.ElementDescription  AS ElementDescription
    FROM ${DOTPAYITEM_SCHEMA}.DOT_PayItem${index}ElementAspect p
    WHERE p.Element.Id = ?
  `;
}

export async function queryQAQCForElement(
  iModel: IModelConnection,
  elementId: string,
  index: DOTPayItemIndex,
): Promise<QAQC | undefined> {
  const bindings = QueryBinder.from([elementId]);

  const reader = iModel.createQueryReader(
    buildQAQCByElementQuery(index),
    bindings,
    { rowFormat: QueryRowFormat.UseECSqlPropertyNames }
  );

  for await (const row of reader) {
    const plain = row.toRow() as any; // { MajorCostValue, MajorTimeValue, ... }
    return QAQC.fromObject(plain);
  }

  // No QAQC info for that element/index
  return undefined;
}
